<script lang="jsx">
import ApmBankTransfer from '@/views/success/apm-bank-transfer.vue';
import Details from '@/views/succezz/details.vue';
export default {
  mixins: [Details],
  components: { ApmBankTransfer },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    renderDetails() {
      return (
        <Details>
          {this.renderAccordionButton()}
        </Details>
      );
    },
    renderDetailsForMobile() {
      const orderSummaryClassName = `text-capitalize opc-succezz-order__summary ${this.isZuoraOutage ? 'opc-succezz-order-zuoraoutage__summary opc-succezz-order-zuoraoutage-mobile__summary': ''}`;
      return (<tile class='opc-succezz-order'>
        <h2 class={orderSummaryClassName}>{this.$t('billing.order_summary')}
        {this.isZuoraOutage ? <span class="opc-succezz-order__zuorage-label">{this.$t('billing.zuoraoutage.payment_processing')}</span>: <span />}</h2>
        <div class='opc-succezz-order__details'>
          {this.renderFirstCartPlan()}
          {this.renderFirstCartPlanSubTitle()}
          {this.renderFirstCartPlanDiscount()}
        </div>
        <div class='opc-succezz-order__expand'>
          {this.renderAccordionButton()}
        </div>
      </tile>);
    },
    renderFurikomiReceipt() {
      return (<apm-bank-transfer />)
    },
    renderAccordionButton() {
      const toggle = () => {
        this.$tracking.buyInteraction('purchase confirmation', `order summary - plans & billing - ${this.isExpand ? 'collapse' : 'expand'}`);
        this.isExpand = !this.isExpand;
      };
      const button = (text, icon) => (
        <zm-button data-testid="checkout-button-472" tabindex='0' aria-expanded={this.isExpand ? 'true' : 'false'} type='link'
                   class='opc-cfgcore__addon__toggle opc-success-no-hide-button' onClick={toggle} suffix-icon={icon}>
          {text}
        </zm-button>
      );
      if (this.isExpand) return button(this.$t('billing.success.confirmation.show_less'), 'zm-icon-up');
      return button(this.$t('billing.success.confirmation.show_full_order_details'), 'zm-icon-down');
    },
    renderFirstCartPlanSubTitle() {
      return (<div class='opc-cart-item' style='margin-bottom: 8px;' innerHTML={this.persistState?.confirmationDetails?.firstPlanSubtitleEle} />);
    },
    renderFirstCartPlan() {
      return (<div class='opc-cart-item' style='margin-bottom: 8px;' innerHTML={this.persistState?.confirmationDetails?.firstPlanTitleEle} />);
    },
    renderFirstCartPlanDiscount() {
      const ele = this.persistState?.confirmationDetails?.firstPlanDiscountEle;
      return (ele ? <div class='opc-cart-item__discount' innerHTML={ele} /> : null);
    },
  },
  render() {
    if (!this.isShowOrderDetails) return null;
    if (this.isExpand) {
      return this.renderDetails();
    }
    if(this.isFurikomi) {
      return this.renderFurikomiReceipt();
    }
    return this.renderDetailsForMobile();
  },
};
</script>
